import Transform from '@ember-data/serializer/transform';

type SubscriptionProfileAddressSerialized = {
  city_name: string;
  country: string;
  number: string;
  postal_code: string;
  street: string;
};

type SubscriptionProfileAddressDeserialized = {
  cityName: string;
  country: string;
  number: string;
  postalCode: string;
  street: string;
};

export default class SubscriptionProfileAddressTransform extends Transform {
  deserialize(
    serialized: SubscriptionProfileAddressSerialized,
  ): SubscriptionProfileAddressDeserialized {
    return {
      cityName: serialized.city_name,
      country: serialized.country,
      number: serialized.number,
      postalCode: serialized.postal_code,
      street: serialized.street,
    };
  }

  serialize(
    deserialized: SubscriptionProfileAddressDeserialized,
  ): SubscriptionProfileAddressSerialized {
    return {
      city_name: deserialized.cityName,
      country: deserialized.country,
      number: deserialized.number,
      postal_code: deserialized.postalCode,
      street: deserialized.street,
    };
  }
}
